export type CompanyId = string & { readonly __brand__: unique symbol };

export function makeCompanyId(id: string): CompanyId {
    return id as CompanyId;
}

export type RouteSubscriptionKind = "client" | "document";